import apiClient from "./APIClient";

class AgentRollbackService {
  getAgentRollbacks = async (page = 1, limit = 10, search = "", createdAtGte, createdAtLte, status) => {
    let query = `rollback/agent?page=${page}&limit=${limit}`;
    
    if (search) query += `&search=${search}`;
    if (createdAtGte) query += `&createdAt_gte=${createdAtGte}`;
    if (createdAtLte) query += `&createdAt_lte=${createdAtLte}`;
    if (status) query += `&status=${status}`;
    
    return await apiClient.get(query);
  }

  markRechargeAsRollback = async (rechargeLogId) => {
    return await apiClient.post(`/rollback/agent/${rechargeLogId}`);
  }

  generateReport = async (filters = {}) => {
    let query = 'rollback/agent?';
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    query += params.toString();
    return await apiClient.get(query);
  }
}

export default new AgentRollbackService();